import React, { useEffect } from 'react';
import { Button, TextField, FormControl, InputLabel, Select,MenuItem, FormHelperText, Grid2, Box } from '@mui/material';
import { useFieldArray ,Controller } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';

const BenifForm = ({onNext, onPrevious}) => {

 
  const { control, register, formState: { errors }, watch, setValue, handleSubmit } = useFormContext();
  const numberOfWives = watch("numberOfWives");
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "familyMembers", // Array name in form data
  });
  const sex = watch("sex");
  const socialStatus = watch("socialStatus");


  const wifeCount = sex === "انثى" && socialStatus === "متزوج/متزوجة" ? 1 : parseInt(numberOfWives || 0);

  useEffect(() => {
    const newWives = Array.from({ length: wifeCount }).map(() => ({
      benifFirstName: '',
      benifSecondName: '',
      benifThirdName: '',
      benifFourthName: '',
      benifMotherName: '',
      land: '',
      house: '',
      housing: '',
      cash: '',
      relation: sex === "انثى" ? 'زوج الشهيد' : 'زوجة الشهيد',
      isWife: true,
    }));
  
    const otherMembers = fields.filter((f) => !f.isWife);
    const combined = [...newWives, ...otherMembers];
  
    replace(combined);
    setValue("familyMembers", combined); // <-- THIS is the key part!
  }, [wifeCount, sex]);


  return (
    <form>
      <Box sx={{ textAlign: "center", marginBottom: 4 }}>
        <h2>اضافة افراد المستفيدين من عائلة الشهيد</h2>
        
      </Box>

      {fields.map((item, index) => (
        <Box  key={item.id} sx={{ marginBottom: 3, padding: 2, borderRadius: 2, border: '1px solid #e0e0e0', backgroundColor: '#f9f9f9' }}>
          <h3>مستفيد {index + 1}</h3>

          {/* Family Member Name */}
          <TextField
  label="اسم المستفيد الاول"
  {...register(`familyMembers[${index}].benifFirstName`, {
    required: "الاسم مطلوب",
    pattern: {
      value: /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]+$/,
      message: "يُسمح فقط بالحروف العربية بدون مسافات"
    }
  })}
  error={!!errors.familyMembers?.[index]?.benifFirstName}
  helperText={errors.familyMembers?.[index]?.benifFirstName?.message}
  fullWidth
  margin="normal"
  sx={{ mb: 2 }}
/>

          <TextField
            label="اسم اب المستفيد"
            {...register(`familyMembers[${index}].benifSecondName`, { required: "الاسم  اب المستفيد مطلوب" , pattern: { 
             value: /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]+$/,
             message: "يُسمح فقط بالحروف العربية بدون مسافات"
            } })}
            error={!!errors.familyMembers?.[index]?.benifSecondName}
            helperText={errors.familyMembers?.[index]?.benifSecondName?.message}
            fullWidth
            margin="normal"
            sx={{ mb: 2 }}
          />

          <TextField
            label="اسم جد المستفيد"
            {...register(`familyMembers[${index}].benifThirdName`, { required: "الاسم جد المستفيد مطلوب" , pattern: { 
             value: /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]+$/,
             message: "يُسمح فقط بالحروف العربية بدون مسافات"
            } })}
            error={!!errors.familyMembers?.[index]?.benifThirdName}
            helperText={errors.familyMembers?.[index]?.benifThirdName?.message}
            fullWidth
            margin="normal"
            sx={{ mb: 2 }}
          />

          <TextField
            label="اسم اب جد المستفيد"
            {...register(`familyMembers[${index}].benifFourthName`, { required: "الاسم اب جد المستفيد مطلوب" , pattern: { 
              value: /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]+$/,
      message: "يُسمح فقط بالحروف العربية بدون مسافات" 
            } })}
            error={!!errors.familyMembers?.[index]?.benifFourthName}
            helperText={errors.familyMembers?.[index]?.benifFourthName?.message}
            fullWidth
            margin="normal"
            sx={{ mb: 2 }}
          />

          <TextField
            label="اسم ام المستفيد الثلاثي"
            {...register(`familyMembers[${index}].benifMotherName`, { required: "الاسم ام المستفيد الثلاثي مطلوب" , pattern: { 
              value: /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\s]+$/,
              message: "يُسمح فقط بالحروف العربية"
            } })}
            error={!!errors.familyMembers?.[index]?.benifMotherName}
            helperText={errors.familyMembers?.[index]?.benifMotherName?.message}
            fullWidth
            margin="normal"
            sx={{ mb: 2 }}
          />
          {/* Relation */}
          <FormControl fullWidth margin="normal" error={!!errors.familyMembers?.[index]?.relation}>
            <InputLabel>الصلة</InputLabel>
            <Select
              label="الصلة"
              {...register(`familyMembers[${index}].relation`, { required: "الصلة مطلوبة" })}
              defaultValue={item.relation}
              disabled={item.isWife} // disable editing if it's an auto-added wife
            >
              <MenuItem value="اب الشهيد">اب الشهيد</MenuItem>
              <MenuItem value="ام الشهيد">ام الشهيد</MenuItem>
              {item.isWife && <MenuItem value="زوج الشهيد">زوج الشهيد</MenuItem>}
              {item.isWife && <MenuItem value="زوجة الشهيد">زوجة الشهيد</MenuItem>}
              <MenuItem value="أخ الشهيد">أخ الشهيد</MenuItem>
              <MenuItem value="اخت الشهيد">اخت الشهيد</MenuItem>
              <MenuItem value="ابن الشهيد">ابن الشهيد</MenuItem>  
              <MenuItem value="بنت الشهيد">بنت الشهيد</MenuItem>
            </Select>
            {errors.familyMembers?.[index]?.relation && (
              <FormHelperText>{errors.familyMembers[index].relation.message}</FormHelperText>
            )}
          </FormControl>

          <FormControl fullWidth margin="normal" error={!!errors.familyMembers?.[index]?.land}>
        <InputLabel>هل المستفيد مستلم لقطعة ارض؟</InputLabel>
        <Controller
          name={`familyMembers[${index}].land`} 
          control={control}
          rules={{ required: "الرجاء اختيار استفادة الاراضي" }}
          render={({ field }) => (
            <Select
              {...field}
              label="هل المستفيد مستلم لقطعة ارض؟"
              sx={{ textAlign: "right", direction: "rtl" }}
            >
              <MenuItem value="كلا">كلا</MenuItem>
              <MenuItem value="نعم">نعم</MenuItem>
            </Select>
          )}
        />
        {errors.familyMembers?.[index]?.land && (
          <FormHelperText>{errors.familyMembers[index].land.message}</FormHelperText>
        )}
      </FormControl>
      <FormControl fullWidth margin="normal" error={!!errors.familyMembers?.[index]?.house}>
  <InputLabel>هل المستفيد مستلم لوحدة سكنية؟</InputLabel>
  <Controller
    name={`familyMembers[${index}].house`} 
    control={control}
    rules={{ required: "الرجاء اختيار استفادة السكن" }}
    render={({ field }) => (
      <Select
        {...field}
        label="هل المستفيد مستلم لوحدة سكنية؟"
        sx={{ textAlign: "right", direction: "rtl" }}
      >
        <MenuItem value="كلا">كلا</MenuItem>
        <MenuItem value="نعم">نعم</MenuItem>
      </Select>
    )}
  />
  {errors.familyMembers?.[index]?.house && (
    <FormHelperText>
      {errors.familyMembers[index].house.message}
    </FormHelperText>
  )}
</FormControl>
      <FormControl fullWidth margin="normal" error={!!errors.familyMembers?.[index]?.housing}>
        <InputLabel>هل المستفيد مستلم منحة عقارية؟</InputLabel>
        <Controller
          name={`familyMembers[${index}].housing`} 
          control={control}
          rules={{ required: "الرجاء اختيار استفادة منحة العقارية" }}
          render={({ field }) => (
            <Select
              {...field}
              label="هل المستفيد مستلم منحة عقارية؟"
              sx={{ textAlign: "right", direction: "rtl" }}
            >
              <MenuItem value="كلا">كلا</MenuItem>
              <MenuItem value="نعم">نعم</MenuItem>
            </Select>
          )}
        />
        {errors.familyMembers?.[index]?.housing && (
    <FormHelperText>
      {errors.familyMembers[index].housing.message}
    </FormHelperText>
  )}
      </FormControl>
      <FormControl fullWidth margin="normal" error={!!errors.familyMembers?.[index]?.cash}>
        <InputLabel>هل المستفيد مستلم بدل نقدي؟ </InputLabel>
        <Controller
          name={`familyMembers[${index}].cash`} 
          control={control}
          rules={{ required: "الرجاء اختيار استفادة منحة النقدي" }}
          render={({ field }) => (
            <Select
              {...field}
              label="هل المستفيد مستلم بدل نقدي؟"
              sx={{ textAlign: "right", direction: "rtl" }}
            >
              <MenuItem value="كلا">كلا</MenuItem>
              <MenuItem value="جزئي">نعم(بدل نقدي جزئي)</MenuItem>
              <MenuItem value="كامل">نعم(بدل نقدي كامل)</MenuItem>
            </Select>
          )}
        />
        {errors.familyMembers?.[index]?.cash && (
    <FormHelperText>
      {errors.familyMembers[index].cash.message}
    </FormHelperText>
  )}
       
      </FormControl>


          {/* File Upload for ID Card */}
          {/* <Controller
            name={`familyMembers[${index}].idCard`}
            control={control}
            render={({ field }) => (
              <Box sx={{ mb: 2 }}>
                <Input
                  {...field}
                  type="file"
                  inputProps={{ accept: '.jpg,.jpeg,.png,.pdf' }}
                  fullWidth
                />
                {errors.familyMembers?.[index]?.idCard && (
                  <p style={{ color: 'red' }}>ID Card is required</p>
                )}
              </Box>
            )}
          /> */}

          {/* Remove Button */}
          {!item.isWife && (
  <Button
    variant="outlined"
    color="secondary"
    onClick={() => remove(index)}
    sx={{ marginTop: 2 }}
  >
    إزالة مستفيد
  </Button>
)}
        </Box>
      ))}

      {socialStatus === "اعزب/عزباء" && (
        <Box sx={{ textAlign: "center", marginBottom: 4 }}>
        <h2>اذا كان الشهيد اعزب انتقل مباشرة الى الخطوة الثالثة اضغط التالي</h2>       
      </Box>
      )}
      {/* Add New Family Member */}
     
      <Box sx={{ textAlign: "center", marginTop: 4 , display: 'none'}}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => append({ name: '', relation: '', idCard: null })}
          sx={{ marginBottom: 2 }}
        >
          إضافة عضو أسرة جديد
        </Button>
      </Box>
      

      {/* Navigation Buttons */}
      <Grid2 container spacing={2} sx={{ marginTop: 4 }}>
        <Grid2 item xs={6} sx={{ textAlign: "right" }}>
          <Button 
            onClick={onPrevious} 
            variant="outlined" 
            color="secondary"
            sx={{ width: '100%' }}
          >
            رجوع
          </Button>
        </Grid2>
        <Grid2 item xs={6} sx={{ textAlign: "left" }}>
        <Button 
  onClick={handleSubmit(onNext)} 
  variant="contained" 
  color="primary"
  sx={{ width: '100%' }}
>
  التالي
</Button>
        </Grid2>
      </Grid2>
    </form>
  );
};

export default BenifForm;
